module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Gc-Ha-Ia.33512477.png";